import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { Crud } from 'core/types/Crud'
import { CrudStore } from 'core/types/crudStore'
import { IJbpPartners } from 'partner360/components/simplePartnerTable'

export const getJbpPartnersCrud = () => {
  return CrudStore.get(CrudStoreItemPartner360.JBPFetchPartnersToAdd) as Crud<IJbpPartners>
}
